/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../clients/content-ai-api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../clients/content-ai-api-client";
import type { ContentUpdateUserArticleMutationRequest, ContentUpdateUserArticleMutationResponse, ContentUpdateUserArticlePathParams } from "../models/ContentUpdateUserArticle";

export function getContentUpdateUserArticleUrl(id: ContentUpdateUserArticlePathParams["id"]) {
  const res = { method: 'PUT', url: `/contents/${id}/user-article` as const }  
  return res
}

/**
 * @summary Set article content after user edition
 * {@link /contents/:id/user-article}
 */
export async function contentUpdateUserArticle(id: ContentUpdateUserArticlePathParams["id"], data: ContentUpdateUserArticleMutationRequest, config: Partial<RequestConfig<ContentUpdateUserArticleMutationRequest>> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const requestData = data  
  
  const res = await request<ContentUpdateUserArticleMutationResponse, ResponseErrorConfig<Error>, ContentUpdateUserArticleMutationRequest>({ method : "PUT", url : getContentUpdateUserArticleUrl(id).url.toString(), data : requestData, ... requestConfig })  
  return res.data
}